<footer class="page-footer">
  <img src="assets/imagens/logo-actuar-invertida@2x.png" class="footer-logo-invertida">
</footer>